var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloudDeactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.271 79C106.349 79 105.565 79.6395 105.215 80.492C103.643 84.3111 99.8857 87 95.5 87C89.701 87 85 82.299 85 76.5V63.5C85 57.701 89.701 53 95.5 53C100.477 53 104.646 56.4633 105.727 61.1116C105.969 62.152 106.829 63 107.897 63H126C127.105 63 128 62.1046 128 61V59C128 57.0292 127.714 55.0623 127.006 53.2232C122.677 41.9788 111.77 34 99 34H92C75.4315 34 62 47.4315 62 64V76C62 92.5685 75.4315 106 92 106H99C112.123 106 123.277 97.5745 127.35 85.838C127.777 84.6068 128 83.3032 128 82V81C128 79.8954 127.105 79 126 79H107.271Z",
    fill: "#C9CDCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 34C27.4315 34 14 47.4315 14 64V76C14 92.5685 27.4315 106 44 106H51C67.5685 106 81 92.5685 81 76V64C81 47.4315 67.5685 34 51 34H44ZM47.5 53C41.701 53 37 57.701 37 63.5V76.5C37 82.299 41.701 87 47.5 87C53.299 87 58 82.299 58 76.5V63.5C58 57.701 53.299 53 47.5 53Z",
    fill: "#A1A4A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5 42.0967C65.6535 47.5709 62 55.3588 62 64V76C62 84.6412 65.6535 92.4292 71.5 97.9034C77.3465 92.4292 81 84.6412 81 76V64C81 55.3588 77.3465 47.5709 71.5 42.0967Z",
    fill: "#515152"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudDeactive);
export default __webpack_public_path__ + "static/media/icon-cloud-deactive.4153e40b47507c8b75042f6f7e30c215.svg";
export { ForwardRef as ReactComponent };